import { Document } from '@contentful/rich-text-types'
import { ModeratorType } from '@fable/types'

export enum ContentTypes {
  author = 'author',
  book = 'book',
  folio = 'folio',
  blog = 'blog',
  event = 'event',
  community = 'community',
  bookList = 'book-list',
  genres = 'genres',
}

export interface CMSPerson {
  name: string
  avatar: { url: string }
  type: string
  slug: string
}

export enum CMSBookListType {
  default = 'Default',
  simple = 'Simple',
  detailed = 'Detailed',
}

export interface CMSBookList {
  name: string
  type: CMSBookListType
  books: CMSBook[]
}

export interface CMSBook {
  title: string
  bookCover: string
  shortDescription: string
  author: string
  clubPick: boolean
  isbn: string
  slug: string
}

export interface CMSQuote {
  sentence: string
  author: string
}

export interface ClubSliderList {
  title: string
  sliderListCollection: { items: ClubsSliderItems[] }
}

export interface ClubsSliderItems {
  title: string
  clubsCollection: { items: CMSClub[] }
}

export interface CMSClub {
  creatorImage: string
  creatorName: string
  currentBook: CMSBook
  featureText: string
  moderatorType: ModeratorType
  slug: string
  theme: '1' | '2' | '3' | '4' | '5'
  themeColor: string
  title: string
}

export interface CMSRichText {
  json: Document
}

export interface CMSImage {
  url: string
  title: string
}

export interface CMSList<TData> {
  listCollection: { items: TData[] }
  title: string
}

export interface CMSPageContent {
  title: string
  valueProps: CMSList<CMSValueProp>
  faqs: CMSList<CMSFaq>
}

export interface CMSFaq {
  title: string
  description: CMSRichText
}

export interface CMSValueProp {
  title: string
  subtitle: string
  image: CMSImage
}
